import { createIcon } from '@chakra-ui/icons';

export const TelegramIcon = createIcon({
  displayName: 'TelegramIcon',
  viewBox: '0 0 32 32',
  path: [
    <path
      key="1"
      d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z"
      fill="#419FD9"
    />,
    <path
      key="2"
      d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z"
      fill="url(#paint0_linear)"
    />,
    <path
      key="3"
      d="M7.1916 15.6479C11.8445 13.5782 14.9471 12.2136 16.4995 11.5543C20.9319 9.67196 21.853 9.34496 22.4533 9.33409C22.5853 9.33182 22.8805 9.36522 23.0718 9.52362C23.2333 9.65742 23.2777 9.83816 23.2989 9.96496C23.3202 10.0918 23.3467 10.3808 23.3256 10.6065C23.0854 13.1833 22.0461 19.4366 21.5173 22.3226C21.2936 23.5438 20.8531 23.9533 20.4266 23.9934C19.4997 24.0804 18.7959 23.368 17.8982 22.7671C16.4934 21.827 15.6999 21.2416 14.3363 20.3242C12.7605 19.264 13.782 18.6812 14.6801 17.7288C14.9151 17.4796 18.9989 13.687 19.0779 13.343C19.0878 13.2999 19.097 13.1395 19.0037 13.0548C18.9103 12.9702 18.7726 12.9991 18.6732 13.0221C18.5323 13.0548 16.2882 14.5692 11.9409 17.5655C11.3039 18.0121 10.7269 18.2296 10.21 18.2182C9.64013 18.2057 8.54393 17.8893 7.729 17.6188C6.72947 17.287 5.93503 17.1117 6.0042 16.5483C6.04023 16.2548 6.43602 15.9547 7.1916 15.6479Z"
      fill="white"
    />,
    <defs key="4">
      <linearGradient
        id="paint0_linear"
        x1="16"
        y1="0"
        x2="16"
        y2="31.7627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AABEE" />
        <stop offset="1" stopColor="#229ED9" />
      </linearGradient>
    </defs>,
  ],
});
